"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Container = styled_components_1.default.div `
	box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%),
		0px 1px 3px 0px rgb(0 0 0 / 12%);
	width: fit-content;
	height: fit-content;
	border-radius: 8px;

	&:not(:last-child) {
		margin-bottom: 2.25rem;
	}
`;
const Title = styled_components_1.default.div `
	height: 45px;
	padding-left: 1.5rem;
	padding-right: 1.5rem;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	border-color: #c1c1c1;
	background-color: ${(props) => props.backgroundColor};

	display: flex;
	align-items: center;
	color: #000000;
	font-weight: bold;
	font-size: 1rem;
	transition: background-color 300ms linear;

	user-select: none;

	-webkit-appearance: none;
	-webkit-tap-highlight-color: transparent;
`;
const WhiteBoard = styled_components_1.default.div `
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
	padding-left: 1.5rem;
	padding-right: 1.5rem;
	padding-bottom: 1.5rem;
	background-color: white;
	font-size: 0.875rem;
	color: #5c5a5a;
	overflow: auto;
`;
const Panel = ({ className, headerBackgroundColor, title, children, }) => {
    return (React.createElement(Container, { className: className },
        React.createElement(Title, { backgroundColor: headerBackgroundColor }, title),
        React.createElement(WhiteBoard, null, children)));
};
exports.default = Panel;
//# sourceMappingURL=Panel.js.map